export enum CourtSystemEntityAuditLogView {
  AdminUserAuditLog,
  UserGroupAuditLog,
  BillingGroupAuditLog,
  CaseAuditLog,
  HearingAuditLog,
}
